import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { STORAGE_KEYS } from './constants';

import { leggiChiave, writeKey } from './storage';

let cached: string | null = null;
let pending: Promise<string> | null = null;

export async function ensureFingerprint(): Promise<string> {
  if (cached) return cached;
  const stored = leggiChiave(STORAGE_KEYS.fingerprint);
  if (stored) {
    cached = stored;
    return stored;
  }
  if (pending) return pending;
  pending = (async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    cached = result.visitorId;
    writeKey(STORAGE_KEYS.fingerprint, cached);
    return cached;
  })();
  return pending;
}

export function getCachedFingerprint(): string | null {
  return cached ?? leggiChiave(STORAGE_KEYS.fingerprint);
}
